/**
 * A restricted account is "on hold" (Ryan, 2026-10-07). It meets one refusal: at sign-in, and only after a correct
 * password, and then on every request a session already open makes. The refusal carries one sentence, written once on
 * the server (backend app/auth ON_HOLD), which every screen shows as it comes. THE WORDS ARE NEVER WRITTEN HERE: this
 * file only recognises the refusal, by the header the server marks it with, and splits the sentence so its email
 * address can be a link. Pure helpers, tested in accountOnHold.test.mjs; components/AccountOnHold.js shows them.
 */
export const ON_HOLD_HEADER = 'x-ug-account';   // backend app/auth ON_HOLD_HEADER; axios hands header names lowercased
export const ON_HOLD_TOAST = 'account-on-hold'; // one notice per tab, however many requests are refused

/** Is this failed request the on-hold refusal? */
export const isAccountOnHold = (err) =>
  err?.response?.status === 403 && String(err.response.headers?.[ON_HOLD_HEADER] || '') === 'on-hold';

/** The server's sentence for the on-hold refusal, or null for any other failure. */
export const onHoldSentence = (err) => {
  const detail = err?.response?.data?.detail;
  return isAccountOnHold(err) && typeof detail === 'string' && detail ? detail : null;
};

const EMAIL = /([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/;

/** A sentence in pieces, each email address its own piece ({ email }), so a screen can make it a mailto link. */
export const emailParts = (text) =>
  String(text || '').split(EMAIL).filter(Boolean).map((s) => (EMAIL.test(s) ? { email: s } : { text: s }));
